/** Display rate: 1 USD = 50 EGP. Server still prices in USD. */
export const USD_TO_EGP = 50;

export function costUsdAmount(usageOrUsd) {
    if (usageOrUsd == null) return 0;
    if (typeof usageOrUsd === 'number') return Number(usageOrUsd) || 0;
    return Number(usageOrUsd.cost_usd) || 0;
}

export function formatCostEgp(usageOrUsd) {
    const egp = costUsdAmount(usageOrUsd) * USD_TO_EGP;
    if (!Number.isFinite(egp) || egp <= 0) return '0 EGP';
    if (egp < 0.01) return `${egp.toFixed(4)} EGP`;
    if (egp < 1) return `${egp.toFixed(3)} EGP`;
    return `${egp.toFixed(2)} EGP`;
}

export function formatElapsedMs(ms) {
    const n = Number(ms);
    if (!Number.isFinite(n) || n <= 0) return '';
    if (n < 1000) return `${Math.round(n)} ms`;
    const s = n / 1000;
    if (s < 60) return `${s < 10 ? s.toFixed(1) : Math.round(s)}s`;
    const m = Math.floor(s / 60);
    const rem = Math.round(s % 60);
    return rem ? `${m}m ${rem}s` : `${m}m`;
}

/** Chat/voice footer: EGP and wait time. No tokens, no model name. */
export function usageFooterText(usage) {
    if (!usage) return '';
    const parts = [];
    const usd = costUsdAmount(usage);
    if (usd) parts.push(formatCostEgp(usage));
    const time = formatElapsedMs(usage.elapsed_ms);
    if (time) parts.push(time);
    return parts.join(' · ');
}
